import { post, get } from "./api";

export const ReviewsApi = {
  list: (id) => get(`/reviews/${id}/`),
  listAllReviews: () => get(`/reviews/`),
  createReviewApi: (data) => post("/reviews/", data),
  createReviewAnonymsApi: (data) => post("/reviews/anonyms/", data),
};
